import { render, staticRenderFns } from "./CloneFormula.vue?vue&type=template&id=1c585259&scoped=true&"
import script from "./CloneFormula.vue?vue&type=script&lang=js&"
export * from "./CloneFormula.vue?vue&type=script&lang=js&"
import style0 from "./CloneFormula.vue?vue&type=style&index=0&id=1c585259&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c585259",
  null
  
)

export default component.exports